import React, { useContext } from "react";
import { StateContext } from "../../../state";
import ConfigComponent from '../../ConfigComponent';
import Title from '../../library/Title';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonContainer } from "../../library/Buttons";
import StartOver from '../../library/StartOver';
// import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
// import { faCcVisa, faCcMastercard, faCcDinersClub, faCcAmex, faCcJcb, faCcDiscover } from '@fortawesome/free-brands-svg-icons';
import './finix.scss';
import { getI18nTranslationOrDefaultValue } from "../../../utils/i18n";
import classnames from 'classnames';

// import styled from "styled-components";
// import ReactTooltip from 'react-tooltip'
// import questionMarkIcon from '../../../assets/images/question-mark-black.png';
// import cvv2 from "../../../assets/images/cvv2.svg";

// const StyledCvvHelp = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   max-width: 90%;
// `;

// const CvvHelp = () => (
//   <StyledCvvHelp>
//     CVV is the 3-digit number on the back of your debit card
//     <img className="cvv-image" src={cvv2} alt="The CVV is a 3-digit number which can be found on the back of your debit card" />
//   </StyledCvvHelp>
// );

// const getCardIconByType = type => {
//   switch(type){
//     case 'visa':
//       return faCcVisa;
//     case 'mastercard':
//       return faCcMastercard;
//     case 'discover':
//       return faCcDiscover;
//     case 'diners':
//       return faCcDinersClub;
//     case 'amex':
//       return faCcAmex;
//     case 'jcb':
//       return faCcJcb;
//     default:
//       return faCreditCard;
//   }
// };

export const FinixView = ({cardType, canSubmit, onSubmit, isFetching, error}) => {
  const [{configuration}] = useContext(StateContext);

  return (<>
    <Title>
      <h1><ConfigComponent config={configuration.recipientLogin.title} /></h1>
    </Title>
    <section className="main">
      <ConfigComponent config={error || configuration.recipientLogin.description} className={classnames({'finix-error': error})} type="p" data={{programName: configuration.programName}} />
    </section>
    <section className="middle">
      <div id="cc-form">
      </div>
      <ButtonContainer>
        <Button
          name="button"
          id="button"
          onClick={onSubmit}
          loading={isFetching}
          disabled={!canSubmit}
        >
          {getI18nTranslationOrDefaultValue(`buttons`, 'submit')}
        </Button>
      </ButtonContainer>
    </section>
    <section>
      <StartOver/>
    </section>
  </>);
};

export default FinixView;
